import { Box } from '@atlaskit/primitives/box';
import { Flex } from '@atlaskit/primitives/components/flex';
import { Grid } from '@atlaskit/primitives/grid';
// eslint-disable-next-line @atlaskit/platform/no-barrel-entry-imports -- no-nested-styles only recognises `media` from this path (not `/responsive/media`)
import { media } from '@atlaskit/primitives/responsive';
import { Stack } from '@atlaskit/primitives/stack';
import { xcss } from '@atlaskit/primitives/xcss';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

export const LoadingSkeleton = () => {
	return (
		<Grid alignItems="center" xcss={responsiveStyles}>
			<Box />
			<Flex alignItems="center" justifyContent="center">
				<Box xcss={skeletonItemsContainer}>
					<Stack space="space.500">
						<Skeleton
							width="100%"
							height="300px"
							isShimmering
							borderRadius={token('radius.medium')}
						/>
						<Skeleton
							width="100%"
							height="150px"
							isShimmering
							borderRadius={token('radius.medium')}
						/>
						<Skeleton
							width="100%"
							height="150px"
							isShimmering
							borderRadius={token('radius.medium')}
						/>
						<Skeleton
							width="100%"
							height="200px"
							isShimmering
							borderRadius={token('radius.medium')}
						/>
						<Skeleton
							width="100%"
							height="200px"
							isShimmering
							borderRadius={token('radius.medium')}
						/>
					</Stack>
				</Box>
			</Flex>
			<Box />
		</Grid>
	);
};

const skeletonItemsContainer = xcss({
	paddingTop: 'space.500',
	paddingBottom: 'space.300',
	paddingLeft: 'space.300',
	paddingRight: 'space.300',
	width: '100%',
});

const responsiveStyles = xcss({
	[media.above.lg]: {
		width: '1200px',
	},
	marginLeft: 'auto',
	marginRight: 'auto',
});
